import { render, staticRenderFns } from "./DetailRevenue.vue?vue&type=template&id=1211b842&scoped=true"
import script from "./DetailRevenue.vue?vue&type=script&lang=js"
export * from "./DetailRevenue.vue?vue&type=script&lang=js"
import style0 from "./DetailRevenue.vue?vue&type=style&index=0&id=1211b842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211b842",
  null
  
)

export default component.exports